import ElementBreite from './enums/ElementBreite';
import { normalizeHexColor } from '@src/utils/normalizeHexColor';

export default class ClientElementSectionLayout {
  constructor(
    sectionId,
    schriftgroesse,
    schriftart,
    hintergrundfarbe,
    hintergrundbild,
    elementBreite = ElementBreite.SECHS_SECHSTEL,
    textAusrichtung = 'linksbuendig',
    textSchriftFarbe = '#000000'
  ) {
    this.sectionId = sectionId;
    this.schriftgroesse = schriftgroesse;
    this.schriftart = schriftart;
    this.elementBreite = elementBreite;

    // section layouts can originate from legacy contracts
    this.hintergrundfarbe = normalizeHexColor(hintergrundfarbe);
    this.hintergrundbild = hintergrundbild;
    this.textAusrichtung = textAusrichtung;
    this.textSchriftFarbe = normalizeHexColor(textSchriftFarbe);
  }

  static fromJSON(json) {
    return new ClientElementSectionLayout(
      json.sectionId,
      json.schriftgroesse,
      json.schriftart,
      json.hintergrundfarbe,
      json.hintergrundbild,
      json.elementBreite,
      json.textAusrichtung,
      json.textSchriftFarbe
    );
  }

  toJSON() {
    // normalize again in case the layout was mutated after construction
    return {
      sectionId: this.sectionId,
      schriftgroesse: this.schriftgroesse,
      schriftart: this.schriftart,
      elementBreite: this.elementBreite,
      hintergrundfarbe: normalizeHexColor(this.hintergrundfarbe),
      hintergrundbild: this.hintergrundbild,
      textAusrichtung: this.textAusrichtung,
      textSchriftFarbe: normalizeHexColor(this.textSchriftFarbe)
    };
  }
}
